/**
 * Created by litao on 2018/10/15.
 */
export default (http) => {
    return {
        /**
         * 用户登录
         * @param data
         * @return {*}
         */
        login(data) {
            return http.json({
                url: '/login',
                data:Object.assign(data||{},{
                    adminFlag:'yf-live'
                })
            })
        },

        /**
         * 获取当前登录用户
         * @return {*}
         */
        getCurrentUser (){
            return http({
                url: '/system/account/info',
                method: 'post'
            });
        },

        /**
         * 获取用户详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/system/account/get?id=${data.id}`
            })
        },
        /**
         * 提交
         * @param data
         * @return {*}
         */
        saveInfo(data) {
            return http.json({
                url: '/system/account/save',
                data
            })
        },

        modifyField (data){
            return http({
                method: 'post',
                url: `/sys/account/modifyField?fieldName=${data.fieldName}&fieldValue=${data.fieldValue}`
            })
        },
        queryByPage (data){
            return http.json({
                url: `/system/account/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            })
        },

        queryAll (data){
            return http.json({
                url: '/system/account/queryAll',
                data
            })
        },
        modifyPassword (data){
            return http.json({
                url: '/system/account/modifyPassword',
                data
            })
        },
        /**
         * 删除后台账户信息
         * @param data
         * @return {*}
         */
        delete(data) {
            return http.json({
                url: `/system/account/delete?id=${data[0].id}`,
                data
            })
        },

        pushError2DingTalk (data){
            return http.json({
                baseURL: '/push2DingTalk',
                url: '/robot/send?access_token=759cad39341a498a78ce498609640e09b771c7342da428dbbb15602702d4f85a',
                data
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/user.js